const propertyUnitBillingPartitionValueGetter = (props) => {
  const { value } = props
  let concatString = ''
  value.forEach((item) => (concatString += item?.name + '\r\n'))
  return concatString
}

export default propertyUnitBillingPartitionValueGetter
